import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { ProductValidationService } from '../services/product-validation-service/product-validation.service';
import { ProductsService } from '../services/products-service/products.service';

@Component({
  selector: 'app-products-search-results',
  templateUrl: './products-search-results.component.html',
  styleUrls: ['./products-search-results.component.scss'],
  standalone: false
})
export class ProductsSearchResultsComponent implements OnInit, OnDestroy {

  foundProducts: any[];
  isLoading: boolean;
  appStrings: AppLocalization;
  noImage;
  private catalogLogoMap: Record<string, string>;
  pageSize: number;
  pageSizeOptions: number[];
  currentPage = 0;
  totalRecords;
  productsPage;
  subs = new Subscription();
  searchString = '';
  numberOfResults;

  constructor(
    private productsService: ProductsService,
    private appInfoService: AppInfoService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private productValidationService: ProductValidationService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {
    this.isLoading = true;
    this.appStrings = this.appInfoService.appStrings;
    this.catalogLogoMap = Object.fromEntries(this.productsService.catalogs.map(c => [c.catalogCode, c.logo]));
    this.currentPage = 0;
    this.searchString = this.activeRoute.snapshot.paramMap.get('searchText');
    this.noImage = this.productsService.noImage;
    this.pageSize = this.productsService.defaultPageSize;
    this.pageSizeOptions = this.productsService.pageSizeOptions;

    this.productsService.getFoundProducts(this.searchString, this.currentPage, this.pageSize).subscribe(products => {
      this.foundProducts = products.tools;
      this.productsPage = products.tools;
      this.numberOfResults = products.count;
      this.isLoading = false;
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  getCatalogLogo(catalogCode: string): string {
    return this.catalogLogoMap[catalogCode] ?? '';
  }

  onProductClick(item: { catalogCode: string, productNumber: string }) {
    this.productValidationService.validateAndOpen(item);
  }

  loadPage(pageNumber: number) {
    this.isLoading = true;
    this.currentPage = pageNumber;
    this.productsService.getFoundProducts(this.searchString, this.currentPage - 1, this.pageSize).subscribe(results => {
      this.foundProducts = results.tools;
      this.isLoading = false;
    });
  }

  loadPageMobile(event: PageEvent) {
    this.isLoading = true;
    this.currentPage = event.pageIndex;
    this.productsService.getFoundProducts(this.searchString, this.currentPage, this.pageSize).subscribe(results => {
      this.foundProducts = results.tools;
      this.isLoading = false;
    });
  }

  updatePageSize() {
    this.isLoading = true;
    if (this.currentPage > this.numberOfResults / this.pageSize) {
      this.currentPage = 0;
    }
    this.productsService.getFoundProducts(this.searchString, this.currentPage, this.pageSize).subscribe(results => {
      this.foundProducts = results.tools;
      this.isLoading = false;
    });
  }
}
